import React from 'react'

export const widgetContextSettings = {
  isWidget: false,
  isWidgetFullSize: false,
  isWidgetActive: false,
  initialWidgetFeature: null,
  handleCloseWidget: function () {},
}

export const WidgetContext = React.createContext(widgetContextSettings)

